import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ColumnListComponent } from './column-list/column-list.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import { CardColumnHeaderComponent } from './cardColumnHeader/cardColumnHeader.component';
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';
import { MatDatePickerComponent } from './matdatepicker/matdatepicker.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DetailRowComponent } from './detailRow/detailRow.component';
import { StatusIndicatorComponent } from './statusIndicator/statusIndicator.component';
import { DetailRowWithIndicatorComponent } from './detailRowWithIndicator/detailRowWithIndicator.component';
import { GlobalErrorComponent } from './global-error/global-error.component';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { DebounceClickDirective } from './debounce/debounce.directive';
import { ToolbarComponent } from '../main/layout/toolbar/toolbar.component';
import { FooterComponent } from '../main/layout/footer/footer.component';
import { SliderComponent } from '../main/layout/slider/slider.component';
import { CookieComponent } from '../features/cookie/cookie.component';
import { DisclaimerComponent } from '../features/disclaimer/disclaimer.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    NgSelectModule
  ],
  declarations: [ColumnListComponent, CardColumnHeaderComponent, ConfirmPopupComponent, MatDatePickerComponent,
     DetailRowComponent, DetailRowWithIndicatorComponent, StatusIndicatorComponent,DebounceClickDirective,
    GlobalErrorComponent, SignaturePadComponent, ToolbarComponent, FooterComponent,SliderComponent,
  FooterComponent, ToolbarComponent, SliderComponent, DisclaimerComponent, CookieComponent, PhoneInputComponent,
],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    MaterialModule,
    ColumnListComponent,
    CardColumnHeaderComponent,
    ConfirmPopupComponent,
    MatDatePickerComponent,
    NgSelectModule,
    DetailRowComponent,
    DetailRowWithIndicatorComponent,
    StatusIndicatorComponent,
    GlobalErrorComponent,
    SignaturePadComponent,
    DebounceClickDirective,
    ToolbarComponent, FooterComponent,SliderComponent,
     DisclaimerComponent, CookieComponent, PhoneInputComponent
  ]
})
export class SharedModule {
}
